export default __webpack_public_path__ + "static/media/User_fill.8aad882e.svg";